// File: ModalUpdateLesson.jsx
import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { getLessonById } from '../../../utils/lessons';
import { urlBase } from '../../../utils/API';
import { HomePage } from '../../../translations/trans';
import { useSelector } from 'react-redux';
import { SolarSystemLoading } from 'react-loadingg';
import { MdDelete } from "react-icons/md";
import { TbReplaceFilled } from "react-icons/tb";
import UpdateLessonContent from './UpdateLessonContent';
import DeleteLessonContent from './DeleteLessonContent';
import ModalAddLessson from './ModalAddLessson';
import './ModalUpdateLesson.css';
const ModalUpdateLesson = ({ lessonId, lessonData, materialCode, show, handleClose }) => {
    const [lesson, setLesson] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showContentMethod, setShowContentMethod] = useState('file');
    const [updateLessonModal, setUpdateLessonModal] = useState(false);
    const [addLess, setAddLess] = useState(false);
    const [contentLesson, setContentLesson] = useState(null);
    const [lessonIdData, setLessonId] = useState(null);
    const [contentLessonDel, setContentLessonDel] = useState(null);
    const [idLessonDel, setIdLessonDel] = useState(null);
    const [delLesson, setDelLesson] = useState(false);

    const { lang, dir } = useSelector(({ language }) => ({
        lang: language.lang,
        dir: language.dir,
    }));

    const getLesson = async () => {
        try {
            const res = await getLessonById({ _id: lessonData?._id });
            setLesson(res?.data?.lesson);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (lessonData?._id) getLesson();
    }, [lessonData]);

    const preventContextMenu = (e) => e.preventDefault();
    const toggleContentView = () =>
        setShowContentMethod((prev) => (prev === 'file' ? 'name' : 'file'));

    const handleShowUpdateLesson = (c, lessonId) => {
        setUpdateLessonModal(true);
        setContentLesson(c);
        setLessonId(lessonId);
        handleClose();
    };

    const handleContentDel = (c, lessonId) => {
        setDelLesson(true);
        setContentLessonDel(c);
        setIdLessonDel(lessonId);
        handleClose();
    };

    const handleAddLesson = () => {
        setAddLess(true);
        handleClose();
    };

    return (
        <div>
            <Modal show={show} onHide={handleClose} centered size="lg" dir={dir}>
                <Modal.Header closeButton>
                    <Modal.Title>{HomePage.updateLessonontent[lang]}</Modal.Title>
                </Modal.Header>

                <div className="d-flex justify-content-between align-items-center px-3 py-2 flex-wrap gap-2">
                    <Button variant="primary" onClick={handleAddLesson}>
                        Add New File
                    </Button>
                   <Button
//   variant={showContentMethod === 'file' ? 'outline-secondary' : 'outline-success'}
  onClick={toggleContentView}
  className={showContentMethod === 'file' ? 'toggle-white' : ''}
>
  {showContentMethod === 'file'
    ? 'Switch to List View'
    : 'Switch to File View'}
</Button>

                </div>

                {!loading ? (
                    <Modal.Body>
                        {showContentMethod === 'file' ? (
                            <div>
                                {lesson?.content?.length > 0 ? (
                                    lesson.content.map((c, i) => {
                                        const fileType = c.type.split('/')[0];
                                        if (fileType === 'image') {
                                            return (
                                                <div key={i} onContextMenu={preventContextMenu} className="mt-5 text-center" style={{ height: "350px" }}>
                                                    <div>
                                                        <MdDelete color="red" size={25} onClick={() => handleContentDel(c, lesson?._id)} />
                                                        <TbReplaceFilled onClick={() => handleShowUpdateLesson(c, lesson?._id)} size={25} color="#283476" />
                                                    </div>
                                                    <hr />
                                                    <img
                                                        src={`${urlBase}/${c.name}`}
                                                        alt="lesson cover"
                                                        style={{ width: '50%', height: '70%', objectFit: 'contain' }}
                                                    />
                                                </div>
                                            );
                                        } else if (fileType === 'video') {
                                            return (
                                                <div key={i} className="mt-4 mb-4" style={{ textAlign: "center" }} onContextMenu={preventContextMenu}>
                                                    <div>
                                                        <MdDelete color="red" size={25} onClick={() => handleContentDel(c, lesson?._id)} />
                                                        <TbReplaceFilled onClick={() => handleShowUpdateLesson(c, lesson?._id)} size={25} color="#283476" />
                                                    </div>
                                                    <hr />
                                                    <video controls controlsList="nodownload" width="100%" height="auto">
                                                        <source src={`${urlBase}/api/files/${c.name}?type=${c?.type}`} type={c.type} />
                                                    </video>
                                                </div>
                                            );
                                        } else if (c.type.includes('pdf')) {
                                            return (
                                                <div key={i} className="mt-4 mb-4 text-center" onContextMenu={preventContextMenu}>
                                                    <div>
                                                        <MdDelete color="red" size={25} onClick={() => handleContentDel(c, lesson?._id)} />
                                                        <TbReplaceFilled onClick={() => handleShowUpdateLesson(c, lesson?._id)} size={25} color="#283476" />
                                                    </div>
                                                    <hr />
                                                    <div className="pdf-container mt-3">
                                                        <iframe
                                                            style={{ backgroundColor: '#fff', borderRadius: '8px' }}
                                                            src={`${urlBase}/${c.name}`}
                                                            width="100%"
                                                            height="350px"
                                                            title="PDF Preview"
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        }
                                        return null;
                                    })
                                ) : (
                                    <p className="text-center text-muted mt-3">No content available.</p>
                                )}
                            </div>
                        ) : (
                            <div className="mt-3 table-responsive">
                                <table className="table table-striped table-bordered align-middle text-center mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>#</th>
                                            <th>File Name</th>
                                            <th>Type</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lesson?.content?.length > 0 ? (
                                            lesson.content.map((c, i) => (
                                                <tr key={i}>
                                                    <td>{i + 1}</td>
                                                    <td className="text-break">
                                                        {c.originalFileName || c.name}
                                                    </td>
                                                    <td>{c.type}</td>
                                                    <td>
                                                        <MdDelete
                                                            color="red"
                                                            size={22}
                                                            style={{ cursor: 'pointer', marginRight: '10px' }}
                                                            onClick={() => handleContentDel(c, lesson?._id)}
                                                        />
                                                        <TbReplaceFilled
                                                            size={22}
                                                            color="#283476"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => handleShowUpdateLesson(c, lesson?._id)}
                                                        />
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" className="text-muted">
                                                    No files found.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </Modal.Body>
                ) : (
                    <div className="d-flex justify-content-center py-4">
                        <SolarSystemLoading />
                    </div>
                )}
            </Modal>

            <UpdateLessonContent
                lessonContent={contentLesson}
                lessonId={lessonIdData}
                materialCode={materialCode}
                show={updateLessonModal}
                handleClose={() => setUpdateLessonModal(false)}
            />

            <DeleteLessonContent
                show={delLesson}
                handleClose={() => setDelLesson(false)}
                contentLessonDel={contentLessonDel}
                idLessonDel={idLessonDel}
            />

            <ModalAddLessson
                show={addLess}
                handleClose={() => setAddLess(false)}
                lessonData={lessonData}
            />
        </div>
    );
};

export default ModalUpdateLesson;
